import React from 'react';
import { useNavigate } from 'react-router-dom';

const PortfolioType = ({ id, img, category, title, rotate }) => {
  const navigate = useNavigate();
  const categoryStyle = {
    Branding: 'bg-red-50 text-red-600',
    Web: 'bg-blue-50 text-blue-600',
    Logo: 'bg-neutral-900 text-white',
  };
  return (
    <div
      onClick={() => navigate(`/portfolio/${id}`)}
      className='
      group
      cursor-pointer
      select-none
      '
    >
      {/* IMAGE */}

      <div
        className={`
        relative
        overflow-hidden
        rounded-2xl
        shadow-sm
        transition
        duration-500
        ease-out
        ${rotate}
        group-hover:rotate-0
        group-hover:-translate-y-2
        group-hover:shadow-xl
        `}
      >
        <img
          src={img}
          alt={title}
          className='
          w-full
          aspect-square
          object-cover
          transition
          duration-700
          ease-out
          group-hover:scale-105
          '
        />

        {/* subtle highlight */}

        <div
          className='
          pointer-events-none
          absolute
          inset-0
          opacity-0
          group-hover:opacity-100
          transition
          duration-500
          bg-gradient-to-t
          from-black/10
          to-transparent
          '
        />
      </div>

      {/* TEXT */}

      <div className='mt-4 space-y-1'>
        {/* CATEGORY */}

        <p
          className={`
  inline-block
  text-xs
  font-medium
  px-2.5
  py-1
  rounded-full
  mb-1
  ${categoryStyle[category]}
  `}
        >
          {category}
        </p>

        {/* TITLE */}

        <h3
          className='
          text-lg
          font-semibold
          leading-tight
          transition
          group-hover:text-black
          '
        >
          {title}
        </h3>

        {/* SUBTEXT */}

        <div
          className='
          flex
          items-center
          gap-2
          text-sm
          text-neutral-500
          mt-1
          transition
          group-hover:text-black
          '
        >
          View project
          <span
            className='
            inline-block
            transition
            duration-300
            group-hover:translate-x-1
            '
          >
            →
          </span>
        </div>
      </div>
    </div>
  );
};

export default PortfolioType;
